const getters = {
  token: state => state.user.token,
  loadmenu: state => state.permission.loadmenu,
  tagsView: state => state.permission.tagsView,
  addRouters: state => state.permission.addRouters,
  userPerms: state => state.permission.userPerms,
  staffList1: state => state.permission.userPerms.staffList1, // 员工列表
  staffList2: state => state.permission.userPerms.staffList2, // 离职列表
  staffList3: state => state.permission.userPerms.staffList3, // 办公室人员

  projectList1: state => state.permission.userPerms.projectList1, // 项目列表
  projectList2: state => state.permission.userPerms.projectList2, // 项目位置
  projectList3: state => state.permission.userPerms.projectList3, // 队员列表
  projectList4: state => state.permission.userPerms.projectList4, // 立项
  projectList5: state => state.permission.userPerms.projectList5, // 进程
  projectList6: state => state.permission.userPerms.projectList6, // 派遣单审核
  projectList7: state => state.permission.userPerms.projectList7, // 考勤
  projectList8: state => state.permission.userPerms.projectList8, // 成本核算
  projectList9: state => state.permission.userPerms.projectList9, // 巡逻打卡
  projectList10: state => state.permission.userPerms.projectList10, // 表扬投诉

  politicsList1: state => state.permission.userPerms.politicsList1, // 采购

  rolesList1: state => state.permission.userPerms.rolesList1, // 公司管理
  rolesList2: state => state.permission.userPerms.rolesList2, // 用户管理
  rolesList3: state => state.permission.userPerms.rolesList3, // 角色管理
  rolesList4: state => state.permission.userPerms.rolesList4, // 合同公司
  rolesList5: state => state.permission.userPerms.rolesList5, // 客户管理

  systemList1: state => state.permission.userPerms.systemList1, // 总则
  systemList2: state => state.permission.userPerms.systemList2, // 行政人事
  systemList3: state => state.permission.userPerms.systemList3, // 财务
  systemList4: state => state.permission.userPerms.systemList4, // 市场
  systemList5: state => state.permission.userPerms.systemList5, // 运营

  finance1: state => state.permission.userPerms.finance1, // 工资
  finance2: state => state.permission.userPerms.finance2, // 服务费

  statistical1: state => state.permission.userPerms.statistical1 // 工资
}
export default getters
